let activeCommandHandler: ((commandId: string) => void) | undefined;

export function setActiveSpaceMouseCommandHandler(handler: ((commandId: string) => void) | undefined): void {
    activeCommandHandler = handler;
}

export function runActiveSpaceMouseCommand(commandId: string): void {
    activeCommandHandler?.(commandId);
}
